import { render } from "./AppLayout.vue?vue&type=template&id=2206b6c6&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"

import "./AppLayout.vue?vue&type=style&index=0&id=2206b6c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2206b6c6"

export default script